module.exports = __webpack_public_path__ + "assets/img/1.be37da2b.png";